const pages = {
  equipment: {
    name: 'equipment',
    subpath: '',
    icon: 'construction',
    component: () => import('../components/Pages/PageAssetList'),
  },
  equipmentModels: {
    name: 'equipmentModels',
    subpath: 'equipment-models',
    icon: 'style',
    component: () => import('../components/Pages/PageModelList'),
  },
  equipmentCategories: {
    name: 'equipmentCategories',
    subpath: 'equipment-categories',
    icon: 'category',
    component: () => import('../components/Pages/PageCategoryList'),
  },
  equipmentManufacturers: {
    name: 'equipmentManufacturers',
    subpath: 'equipment-manufacturers',
    icon: 'store',
    component: () => import('../components/Pages/PageManufacturerList'),
  },
  equipmentLocations: {
    name: 'equipmentLocations',
    subpath: 'equipment-locations',
    icon: 'place',
    component: () => import('../components/Pages/PageLocationList'),
  },
  equipmentActivityTypes: {
    name: 'equipmentActivityType',
    subpath: 'equipment-activity-types',
    icon: 'event',
    component: () => import('../components/Pages/PageActivityTypeList'),
  },
  equipmentStatuses: {
    name: 'equipmentStatus',
    subpath: 'equipment-statuses',
    icon: 'info',
    component: () => import('../components/Pages/PageAssetStatusList'),
  },
  equipmentUsers: {
    name: 'equipmentUsers',
    subpath: 'equipment-users',
    icon: 'face',
    component: () => import('../components/Pages/PageUserList'),
  },
  equipmentClients: {
    name: 'equipmentClients',
    subpath: 'equipment-clients',
    icon: 'supervised_user_circle',
    component: () => import('../components/Pages/PageClientList'),
  },
  equipmentDetail: {
    name: 'equipmentDetail',
    subpath: 'equipment-detail',
    component: () => import('../components/Pages/PageAssetDetail'),
  },
  activityDetail: {
    name: 'activityDetail',
    subpath: 'activity-detail',
    component: () => import('../components/Pages/PageActivityDetail'),
  },
  attachmentDetail: {
    name: 'attachmentDetail',
    subpath: 'attachment-detail',
    component: () => import('../components/Pages/PageAttachmentDetail'),
  },
}

export default pages